"use client"

import { SOURCE_FILTER_ROW, sourceFilterPill } from "@/components/source-filter-pill"

export type LewdvaultSort = "" | "popular"

interface LewdvaultSortTabsProps {
  value: LewdvaultSort
  onChange: (value: LewdvaultSort) => void
}

// LewdVault only has two real sort orders — unlike HentaiEra's six actual
// sections, a full-screen tile picker for "Latest" vs "Hot" made the user
// click through a whole extra screen before seeing any content at all.
// These are compact tabs instead, defaulting to Latest, matching how every
// other source's default listing behaves.
const OPTIONS: { value: LewdvaultSort; label: string }[] = [
  { value: "", label: "Latest" },
  { value: "popular", label: "Hot" },
]


export function LewdvaultSortTabs({ value, onChange }: LewdvaultSortTabsProps) {
  return (
    <div className={SOURCE_FILTER_ROW}>
      {OPTIONS.map((opt) => {
        const isActive = value === opt.value
        return (
          <button
            key={opt.value || "latest"}
            onClick={() => onChange(opt.value)}
            className={sourceFilterPill(isActive)}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
